/**
 * Bulk-replaces all object keys strings with object values strings in {text}. Prevents cumulative replacement issues.
 * https://stackoverflow.com/a/37949642
 */
export const bulkReplace = (text: string, replacements: Map<string, string>): string => {
    const regex: string[] = [];

    replacements.forEach((value, key) => {
        regex.push(key.replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
    });

    return text.replace(new RegExp(regex.join('|'), 'g'), matched => replacements.get(matched)!);
};

export const getFileNameWithoutExtension = (fileName: string): string => fileName.split('.').slice(0, -1).join('.');

export const insertTextAtIndex = (text: string, textToInsert: string, index: number): string =>
    text.slice(0, index) + textToInsert + text.slice(index);

export const replaceTextAtPosition = (
    text: string,
    textToInsert: string,
    selectionStart: number,
    selectionEnd: number,
): string => text.slice(0, selectionStart) + textToInsert + text.slice(selectionEnd);

export const escapeRegex = (value: string): string => value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const limitLengthWithConfiguredSuffix = (str: String, limit: number, suffix = '...'): string =>
    str.length > limit ? str.slice(0, limit) + suffix : str.toString();

export const limitLengthWithConfiguredPrefix = (str: String, limit: number, prefix = '...'): string =>
    str.length > limit ? prefix + str.slice(-limit) : str.toString();

export const capitalizeFirstLetter = (value: string): string => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};

export const compareCaseInsensitive = (a: string, b: string): number => a.toLowerCase().localeCompare(b.toLowerCase());

export const getFirstChar = (text: string): string => text.substring(0, 1);

export const removePx = (value: string | number): number => {
    // If it's already a number, return it
    if (typeof value === 'number') return value;

    // Return 0 if value is empty or undefined
    if (!value) return 0;

    // Remove 'px' and any whitespace, then convert to number
    const cleaned = value.replace(/px/gi, '').trim();
    const number = parseFloat(cleaned);

    // Return 0 if the result is NaN, otherwise return the number
    return isNaN(number) ? 0 : number;
};
